<template>
  <router-view />
</template>

<script>
export default {
  name: 'Cancelled'
}
</script>

<style scoped>

</style>
